export default class EventDispatcher {
  constructor() {
    this._events = {}
  }

  on(name, callback) {
    var listeners = this._events[name]
    if (listeners == null) {
      listeners = []
      this._events[name] = listeners
    }
    for (var i = 0, len = listeners.length; i < len; i++) {
      if (listeners[i] === callback) {
        return
      }
    }

    if (callback) {
      this._events[name].push(callback)
    }
  }

  off(name, callback) {
    var listeners = this._events[name]
    if (!listeners) {
      return
    }

    for (var i = 0, len = listeners.length; i < len; i++) {
      if (listeners[i] === callback) {
        listeners.splice(i, 1)
        break
      }
    }
  }

  emit(name, payload) {
    if (!name) {
      return null
    }

    var listeners = this._events[name]
    if (typeof listeners !== 'object' || listeners.length === 0) {
      return
    }

    for (var i = 0, len = listeners.length; i < len; i++) {
      if (typeof listeners[i] === 'function') {
        listeners[i](payload)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./assets/js/base/EventDispatcher.jsx